import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import Alert from '../../ui-elements/alerts/Alert';
import '../../css/forms/default-forms.css'

export default class ProfileChangePassword extends Component {

  constructor(props) {
    super(props);
    const userData = path(['userData'], props) || {};
    this.state = {
      oldPassword: '',
      newPassword: '',
      verifyPassword: '',
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  render() {
    const userData = path(['userData'], this.props) || {};
    let passwordsMatch = null;
    if(this.state.newPassword !== this.state.verifyPassword) {
      passwordsMatch = (
        <Alert className="alert alert-danger alert-bordered">
          <span>Passwords do not match please retype.</span>
        </Alert>
      );
    }
    return (
      <div className="row form-inline" style={{ paddingLeft: '20px' }}>
        <div className="form-group">
          <label htmlFor="op">Old Password</label>
          <input type="password" id="op" name="oldPassword" style={{ borderRadius: '4px' }} onChange={(value) => this.onChange(value)} className="form-control" />
        </div>
        <div className="form-group">
          <label htmlFor="np">New Password</label>
          <input type="password" id="np" name="newPassword" style={{ borderRadius: '4px' }} onChange={(value) => this.onChange(value)} className="form-control" />
        </div>
        <div className="form-group">
          <label htmlFor="vp">Verify Password</label>
          <input type="password" id="vp" name="verifyPassword" style={{ borderRadius: '4px' }} onChange={(value) => this.onChange(value)} className="form-control" />
        </div>
        <div className="col-12" style={{ paddingTop: '20px', marginLeft: '-10px' }}>
          {passwordsMatch}
        </div>
      </div>
    );
  }
}

ProfileChangePassword.propTypes = {
  handler: PropTypes.func,
  userData: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/common/ProfileChangePassword/index.js